<div class="radio-group">
  <label class="radio-label">
    <input
      type="radio"
      name="notToggle"
      [value]="false"
      [(ngModel)]="not"
      (change)="toggleNot()"
    />
    <span class="circle-icon equal">=</span>
    {{ "notToggle.normal" | translate }}
  </label>
  <label class="radio-label">
    <input
      type="radio"
      name="notToggle"
      [value]="true"
      [(ngModel)]="not"
      (change)="toggleNot()"
    />
    <span class="circle-icon not-equal">≠</span>
    {{ "notToggle.niet" | translate }}
  </label>
</div>
